import React from 'react';
import SegmentedButtonItem from './SegmentedButtonItem';
import './SegmentedButton.css';

// Explicit thermostat mode. Reflects the current mode and sets it; the implicit transitions still
// happen on the backend (touching the temperature -> Active, the position -> Manual), so this control
// just keeps in sync and covers the cases those transitions can't express (entering Reposo, resuming
// Automático from Manual).
const MODES = [
  { label: 'Automático', value: 'Active' },
  { label: 'Reposo', value: 'StandBy' },
  { label: 'Manual', value: 'Manual' },
];

const ModeControl = ({ mode, onSelect }) => (
  <div className="btn-group d-flex" role="group">
    {MODES.map((m) => (
      <SegmentedButtonItem
        key={m.value}
        option={m.label}
        isSelected={m.value === mode}
        onClick={() => onSelect(m.value)}
      />
    ))}
  </div>
);

export default ModeControl;
